import React from "react";
import App from "./../app.jsx";
import { Outlet, Navigate } from "react-router-dom";
import Home from "../pages/dashboard/dashboard.js";
import ExtraError from "./../pages/extra/extra-error.js";
import Login from "./../pages/user/login.js";
import LoginV3 from "./../pages/user/login-v2.js";
import AutoLogin from "../pages/user/AutoLogin.jsx";
import PrivateRoute from "./PrivateRoute";
import ManageStaff from "../pages/staff/manageStaff.js";
import AddStaff from "../pages/staff/AddStaff.js";
import UpdateStaff from "../pages/staff/updateStaff.js";
import UpdatePassword from "../pages/staff/UpdatePassword.jsx";
import WeeklySchedule from "../pages/staff/weeklySchedule.js";
// Staff: "Staff Shift Report" = all staff shift list (sidebar)
import StaffShiftReport from "../pages/staff/allStaffsShiftReport.jsx";
// Staff: per-user work report (workReport/:UserName)
import StaffWorkReportPerUser from "../pages/staff/singleStaffShiftReport.jsx";
import StaffPayoutHistory from "../pages/staff/StaffPayoutHistory.jsx";
import StaffLeave from "../pages/staff/StaffLeave.jsx";
import CreateItem from "../pages/items/createItem.jsx";
import ManageItems from "../pages/items/ManageItems.js";
import BulkEditItems from "../pages/items/bulkEditItem.js";
import BulkUploadProducts from "../pages/items/BulkUploadProducts.jsx";
import BulkUploadGuide from "../pages/items/BulkUploadGuide.jsx";
import UpdateItemInventory from "../pages/items/UpdateItemInventory.jsx";
import UpdateItemInventoryLedger from "../pages/items/UpdateItemInventoryLedger.jsx";
import ManageRecipes from "../pages/recipes/ManageRecipes.jsx";
import CreateRecipe from "../pages/recipes/CreateRecipe.jsx";
import ManageBatch from "../pages/batches/ManageBatch.jsx";
import CreateUpdateBatch from "../pages/batches/CreateUpdateBatch.jsx";
import ManageMedia from "../pages/media/ManageMedia.jsx";
import ManageCategories from "../pages/categories/manageCategories.jsx";
import AddCategory from "../pages/categories/addCategory/addCategory.js";
import AddMenu from "../pages/Menu/addMenu.js";
import ManageMenus from "../pages/Menu/manageMenu.js";
import UpdateMenu from "../pages/Menu/updateMenu.js";
import ManageDiscount from "../pages/discount/manageDiscount.js";
import ManageDeals from "../pages/deal/ManageDeals.js";
import CreateDeal from "../pages/deal/createDeal.jsx";
import UpdateDeal from "../pages/deal/updateDeal.jsx";
import BranchEditDeal from "../pages/deal/branchEditDeal.jsx";
import UpdateCategory from "../pages/categories/updateCategory.js";
import AddCustomer from "../pages/customer/customer/addCustomer.js";
import ManageCustomers from "../pages/customer/customer/manageCustomer.jsx";
import ManageCustomersGroup from "../pages/customer/GroupTypes/manageCustomerGroup.jsx";
import AddModifierGroup from "../pages/modifiers/addModifierGroup.js";
import ManageModifierGroups from "../pages/modifiers/manageModifireGroups.jsx";
import UpdateCustomer from "../pages/customer/customer/updateCustomer.js";
import CustomerWallet from "../pages/customer/ledger/customerWallet.jsx";
import UpdateModifierGroup from "../pages/modifiers/updateModifierGroup.js";
import AddDiscount from "../pages/discount/addDiscount.jsx";
import UpdateItem from "../pages/items/updateItem.jsx";
import BranchEditItem from "../pages/items/branchEditItem.jsx";
import UpdateDiscount from "../pages/discount/updateDiscount.js";
import AddRole from "../pages/role/addRole.js";
import ManageRole from "../pages/role/manageRole.js";
import UpdateRole from "../pages/role/updateRole.js";
import Profile from "../pages/profile/profile.js";
import Settings from "../pages/setting/setting.js";
import GoFatafatSettings from "../pages/gofatafat/goFatafatSettings.jsx";
import ManageCampaigns from "../pages/customer/campaigns/manageCampaigns.jsx";
import ManageOrder from "../pages/order/manageOrder.js";
import ManageDevices from "../pages/devices/manageDevices.js";
import PrintingReceipts from "../pages/printing Receipts/printingReceipts.js";
import PaymentMethods from "../pages/paymentMethod/paymentMethod.js";
// Serving Hours functionality moved to Service Areas - routes commented out
// import ManageServiceTime from "../pages/tableManagement/manageServiceTime.js";
// import AddServiceTime from "../pages/tableManagement/addServiceTime.js";
// import UpdateServiceTime from "../pages/tableManagement/updateServiceTime.js";
import ManageReservations from "../pages/tableManagement/reservation.jsx";
import ManageDiningAreas from "../pages/tableManagement/diningArea/DiningArea.jsx";
import AddDiningArea from "../pages/tableManagement/diningArea/addDiningArea.jsx";
import UpdateDiningArea from "../pages/tableManagement/diningArea/updateServiceArea.jsx";
import UpdateServiceArea from "../pages/tableManagement/updateServiceArea.js";
import ManagePettyCash from "../pages/PettyCash/managePettyCash.jsx";
import PricingSubscriptions from "../pages/setting/Pricing&Subscriptions.js";
import CompanyBilling from "../pages/setting/companyBilling.js";
import StripePaymentReturn from "../pages/payment/stripePaymentReturn.jsx";
import ManageCategoryDepartments from "../pages/categoryDepartment/manageCategoryDepartment.jsx";
import ManageVoucher from "../pages/voucher/manageVoucher.js";
import AddVoucher from "../pages/voucher/addVoucher.jsx";
import UpdateVoucher from "../pages/voucher/updateVoucher.js";
import DashboardV3 from "../pages/dashboard/dashboard-v3.js";
import DashboardV2 from "../pages/dashboard/dashboard-v2.js";
import DashboardV1 from "../pages/dashboard/dashboard-v1.js";
import OrderDetailsView from "../pages/order/orderDetailView.js";
import CustomerReport from "../pages/report/customerReport.jsx";
import RiderReport from "../pages/report/riderReport.jsx";
import RestaurantPerformanceReport from "../pages/report/restaurantPerformanceReport.jsx";
import MarketplaceSettlementReport from "../pages/report/marketplaceSettlementReport.jsx";
import MarketplaceOrderEarningsReport from "../pages/report/marketplaceOrderEarningsReport.jsx";
import SalesBreakdownByTime from "../pages/report/salesBreakdownByTime.jsx";
import SalesByProducts from "../pages/report/salesByProducts.jsx";
import ZReport from "../pages/report/zReport.jsx";
import PurchaseSupplierReport from "../pages/report/purchaseSupplierReport.jsx";
import RequisitionReport from "../pages/report/requisitionReport.jsx";
import MasterInventoryReport from "../pages/report/masterInventoryReport.jsx";
import StaffActivityLogReport from "../pages/report/staffActivityLogReport.jsx";
import PettyFloatCashReport from "../pages/report/pettyFloatCashReport.jsx";
import ReconciliationReport from "../pages/report/reconciliationReport.jsx";
import ReconciliationReportNew from "../pages/report/reconciliationReportNew.jsx";
import ReconciliationReportDetail from "../pages/report/reconciliationReportDetail.jsx";
// Report: "Staff Work Report" list/summary (sidebar under Staff)
import StaffWorkReportList from "../pages/report/StaffWorkReport.jsx";
import UpdateStaffSchedule from "../pages/staff/staffSchedule.jsx";
import StaffScheduleManager from "../pages/staff/StaffScheduleManager.jsx";
import AddSupplier from "../pages/supplier/addSupplier.js";
import ManageSuppliers from "../pages/supplier/manageSupplier.jsx";
import UpdateSupplier from "../pages/supplier/updateSupplier.js";
import UpdateSupplierProducts from "../pages/supplier/updateSupplierProducts.jsx";
import ManagePurchaseOrders from "../pages/purchaseOrder/managePurchaseOrders.js";
import CreatePurchaseOrder from "../pages/purchaseOrder/createPurchaseOrder.js";
import UpdatePurchaseOrder from "../pages/purchaseOrder/updatePurchaseOrder.js";
import UpdatePurchaseOrderItems from "../pages/purchaseOrder/updatePurchaseOrderItems.js";
import UpdatePurchaseOrderPayments from "../pages/purchaseOrder/updatePurchaseOrderPayments.js";
import ManageRequisitions from "../pages/requisition/manageRequisitions.jsx";
import CreateRequisition from "../pages/requisition/createRequisition.jsx";
import UpdateRequisition from "../pages/requisition/updateRequisition.jsx";
import UpdateRequisitionItems from "../pages/requisition/updateRequisitionItems.jsx";
import TableSpentReport from "../pages/report/TableSpentReport.jsx";
import DealPerformanceReport from "../pages/report/DealPerformanceReport.jsx";
import ManageCategoryTypes from "../pages/categoryTypes/manageCategoryTypes.jsx";
import ManageBranches from "../pages/setting/branches/manageBranches.jsx";
import CreateBranch from "../pages/setting/branches/createBranch.jsx";
import UpdateBranch from "../pages/setting/branches/updateBranch.jsx";

const AppRoute = [
  {
    // Pathless layout so child routes (report/*, Order/*, …) match reliably under RR7.
    element: <App />,
    children: [
      {
        path: "",
        element: <PrivateRoute />,
        children: [
          { path: "", element: <Home /> }, // Root path shows dashboard
          { path: "dashboard", element: <Home /> },
          { path: "dashboard/v3", element: <DashboardV3 /> },
          { path: "dashboard/v2", element: <DashboardV2 /> },
          { path: "dashboard/v1", element: <DashboardV1 /> },
        ],
      },
      {
        path: "user/*",
        element: <Outlet />,
        children: [
          { path: "login", element: <Login /> },
          { path: "login-v3", element: <LoginV3 /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "auto-login",
        element: <AutoLogin />,
      },
      {
        path: "payment",
        element: <PrivateRoute />,
        children: [
          { path: "stripe-return", element: <StripePaymentReturn /> },
        ],
      },
      {
        path: "team/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageTeam", element: <ManageStaff /> },
          { path: "addTeamMember", element: <AddStaff /> },
          { path: "updateTeamMember/:UserName", element: <UpdateStaff /> },
          { path: "updatePassword/:UserName", element: <UpdatePassword /> },
          { path: "weeklySchedule/:UserName", element: <WeeklySchedule /> },
          { path: "teamSchedule/:UserName", element: <UpdateStaffSchedule /> },
          { path: "schedule", element: <StaffScheduleManager /> },
          { path: "staffShiftReport", element: <StaffShiftReport /> },
          { path: "staffWorkReport", element: <StaffWorkReportList /> },
          { path: "payouts", element: <StaffPayoutHistory /> },
          { path: "workReport/:UserName", element: <StaffWorkReportPerUser /> },
          { path: "payouts/:userName", element: <StaffPayoutHistory /> },
          { path: "leave", element: <StaffLeave /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "items/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageItems", element: <ManageItems /> },
          { path: "manageItems/:RootCat_ID", element: <ManageItems /> },
          // With IsCombo parameter
          { path: "createItem/:ProductType/:IsCombo", element: <CreateItem /> },
          // Without IsCombo parameter
          { path: "createItem/:ProductType", element: <CreateItem /> },
          { path: "bulkUploadProducts", element: <BulkUploadProducts /> },
          { path: "bulkUploadGuide", element: <BulkUploadGuide /> },
          { path: "bulkEditItems", element: <BulkEditItems /> },
          { path: "updateItem/:itemId", element: <UpdateItem /> },
          { path: "branchEditItem/:itemId", element: <BranchEditItem /> },
          { path: "updateItemInventory/:itemId", element: <UpdateItemInventory /> },
          { path: "updateItemInventoryLedger/:itemId", element: <UpdateItemInventoryLedger /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "Food-menu/*",
        element: <PrivateRoute />,
        children: [
          { path: "addFoodMenu", element: <AddMenu /> },
          { path: "manageFoodMenu", element: <ManageMenus /> },
          { path: "updateFoodMenu/:menuId", element: <UpdateMenu /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "recipes/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageRecipes", element: <ManageRecipes /> },
          { path: "createRecipe/:menuItemId", element: <CreateRecipe /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "batches/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageBatch", element: <ManageBatch /> },
          { path: "createBatch", element: <CreateUpdateBatch /> },
          { path: "updateBatch/:batchId", element: <CreateUpdateBatch /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "media/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageMedia", element: <ManageMedia /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "role/*",
        element: <PrivateRoute />,
        children: [
          { path: "addStaffRole", element: <AddRole /> },
          { path: "manageStaffRole", element: <ManageRole /> },
          { path: "updateStaffRole/:roleId", element: <UpdateRole /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "diningManagement/*",
        element: <PrivateRoute />,
        children: [
          // Serving Hours functionality moved to Service Areas - routes commented out
          // { path: "servingHours", element: <ManageServiceTime /> },
          // { path: "addServingHours", element: <AddServiceTime /> },
          // { path: "updateServingHours/:id", element: <UpdateServiceTime /> },
          { path: "reservation", element: <ManageReservations /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "pettyCash/*",
        element: <PrivateRoute />,
        children: [
          { path: "managePettyCash", element: <ManagePettyCash /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "diningAreas/*",
        element: <PrivateRoute />,
        children: [
          { path: "", element: <ManageDiningAreas /> },
          { path: "addDiningArea", element: <AddDiningArea /> },
          { path: "updateDiningArea/:sA_ID", element: <UpdateDiningArea /> },
          { path: "updateServiceArea/:id", element: <UpdateServiceArea /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "/*",
        element: <PrivateRoute />,
        children: [
          { path: "profile", element: <Profile /> },
          { path: "paymentMethod", element: <PaymentMethods /> },
          { path: "manageDevices", element: <ManageDevices /> },
          { path: "customer/addCustomer", element: <AddCustomer /> },
          { path: "customer/manageCustomer", element: <ManageCustomers /> },
          {
            path: "customerGroup/manageCustomerGroup",
            element: <ManageCustomersGroup />,
          },
          {
            path: "customer/updateCustomer/:custGuid",
            element: <UpdateCustomer />,
          },
          {
            path: "customer/wallet/:custGuid",
            element: <CustomerWallet />,
          },
          {
            path: "campaigns/manageCampaigns",
            element: <Navigate to="/gofatafat/campaigns" replace />,
          },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "/*",
        element: <PrivateRoute />,
        children: [
          {
            path: "Departments",
            element: <ManageCategoryDepartments />,
          },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "/*",
        element: <PrivateRoute />,
        children: [
          {
            path: "CategoryTypes",
            element: <ManageCategoryTypes />,
          },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "branches/*",
        element: <PrivateRoute />,
        children: [
          { path: "", element: <ManageBranches /> },
          { path: "create", element: <CreateBranch /> },
          { path: "update/:branchId", element: <UpdateBranch /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "setting/*",
        element: <PrivateRoute />,
        children: [
          { path: "", element: <Settings /> },
          {
            path: "Pricing&Subscriptions",
            element: <PricingSubscriptions />,
          },
          {
            path: "Billing",
            element: <Navigate to="/administration/Billing" replace />,
          },
          {
            path: "billing",
            element: <Navigate to="/administration/billing" replace />,
          },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "gofatafat/*",
        element: <PrivateRoute />,
        children: [
          { path: "", element: <Navigate to="/gofatafat/settings" replace /> },
          { path: "settings", element: <GoFatafatSettings /> },
          { path: "campaigns", element: <ManageCampaigns /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "administration/*",
        element: <PrivateRoute />,
        children: [
          {
            path: "Billing",
            element: <CompanyBilling />,
          },
          {
            path: "billing",
            element: <CompanyBilling />,
          },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "/*",
        element: <PrivateRoute />,
        children: [
          { path: "printingReceipts", element: <PrintingReceipts /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "Order/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageOrder", element: <ManageOrder /> },
          { path: "orderDetails/:orderId", element: <OrderDetailsView /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "discount/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageDiscount", element: <ManageDiscount /> },
          { path: "adddiscount", element: <AddDiscount /> },
          { path: "updatediscount/:discountId", element: <UpdateDiscount /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "deal/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageDeals", element: <ManageDeals /> },
          { path: "createDeal", element: <CreateDeal /> },
          { path: "updateDeal/:dealId", element: <UpdateDeal /> },
          { path: "branchEditDeal/:dealId", element: <BranchEditDeal /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "Supplier/*",
        element: <PrivateRoute />,
        children: [
          { path: "addSupplier", element: <AddSupplier /> },
          { path: "manageSupplier", element: <ManageSuppliers /> },
          {
            path: "updateSupplier/:sID",
            element: <UpdateSupplier />,
          },
          {
            path: "updateSupplierProducts/:sID",
            element: <UpdateSupplierProducts />,
          },
        ],
      },
      {
        path: "purchaseOrder/*",
        element: <PrivateRoute />,
        children: [
          {
            path: "managePurchaseOrders",
            element: <ManagePurchaseOrders />,
          },
          {
            path: "createPurchaseOrder",
            element: <CreatePurchaseOrder />,
          },
          {
            path: "updatePurchaseOrder/:poId",
            element: <UpdatePurchaseOrder />,
          },
          {
            path: "updatePurchaseOrderItems/:poId",
            element: <UpdatePurchaseOrderItems />,
          },
          {
            path: "updatePurchaseOrderPayments/:poId",
            element: <UpdatePurchaseOrderPayments />,
          },
        ],
      },
      {
        path: "requisition/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageRequisitions", element: <ManageRequisitions /> },
          { path: "createRequisition", element: <CreateRequisition /> },
          { path: "updateRequisition/:id", element: <UpdateRequisition /> },
          { path: "updateRequisitionItems/:id", element: <UpdateRequisitionItems /> },
        ],
      },
      {
        path: "voucher/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageVoucher", element: <ManageVoucher /> },
          { path: "addVoucher", element: <AddVoucher /> },
          { path: "updateVoucher/:voucherId", element: <UpdateVoucher /> },
          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "Add-ons/*",
        element: <PrivateRoute />,
        children: [
          { path: "Add-onsGroups", element: <ManageModifierGroups /> },
          { path: "addModifierGroup", element: <AddModifierGroup /> },
          {
            path: "updateModifierGroup/:mGID",
            element: <UpdateModifierGroup />,
          },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "categories/*",
        element: <PrivateRoute />,
        children: [
          { path: "manageCategories", element: <ManageCategories /> },
          { path: "createItem", element: <CreateItem /> },
          { path: "addCategory", element: <AddCategory /> },
          { path: "addCategory/:rootCatID", element: <AddCategory /> },
          { path: "updateCategory/:rootCatID", element: <UpdateCategory /> },

          { path: "*", element: <ExtraError /> },
        ],
      },
      {
        path: "report/*",
        element: <PrivateRoute />,
        children: [
          { path: "customerReport", element: <CustomerReport /> },
          { path: "riderReport", element: <RiderReport /> },
          { path: "restaurantPerformance", element: <RestaurantPerformanceReport /> },
          { path: "marketplaceSettlementReport", element: <MarketplaceSettlementReport /> },
          { path: "marketplaceOrderEarningsReport", element: <MarketplaceOrderEarningsReport /> },
          { path: "salesBreakdownByTime", element: <SalesBreakdownByTime /> },
          { path: "salesByProducts", element: <SalesByProducts /> },
          { path: "zReport", element: <ZReport /> },
          { path: "purchaseSupplierReport", element: <PurchaseSupplierReport /> },
          { path: "requisitionReport", element: <RequisitionReport /> },
          { path: "masterInventoryReport", element: <MasterInventoryReport /> },
          { path: "staffActivityLogReport", element: <StaffActivityLogReport /> },
          { path: "pettyFloatCashReport", element: <PettyFloatCashReport /> },
          { path: "reconciliationReport", element: <ReconciliationReport /> },
          { path: "reconciliationReport/new", element: <ReconciliationReportNew /> },
          { path: "reconciliationReport/:id", element: <ReconciliationReportDetail /> },
          { path: "tableSpent", element: <TableSpentReport /> },
          { path: "dealPerformance", element: <DealPerformanceReport /> },
          { path: "*", element: <ExtraError /> },
        ],
      },

    ],
  },
];
export default AppRoute;
